import config from 'constants/apiConfig';
import axios from 'axios';

import {
  FETCH_GEOLOCATION_RISK_ORG_REQUEST,
  FETCH_GEOLOCATION_RISK_ORG_SUCCESS,
  FETCH_GEOLOCATION_RISK_ORG_ERROR,
} from 'constants/alert-action-types';
import { toast } from 'react-toastify';
import { noAutoClose } from 'assets/data/config';

function fetchGeolocationRiskOrgRequest() {
  return {
    type: FETCH_GEOLOCATION_RISK_ORG_REQUEST,
  };
}

function fetchGeolocationRiskOrgSuccess(aor, data) {
  return {
    type: FETCH_GEOLOCATION_RISK_ORG_SUCCESS,
    payload: { aor, data },
  };
}

function fetchGeolocationRiskOrgError(error) {
  const errorMessage =
    'fetch Geolocation Risk Alert Error\n\n' +
    ((!!error &&
      !!error.message &&
      typeof error.message === 'string' &&
      error.message) ||
      '') +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: FETCH_GEOLOCATION_RISK_ORG_ERROR,
  };
}

export function fetchGeolocationRiskOrg(
  group_guid,
  selectedDatetime,
  aor = null,
  newReport = false
) {
  let interval;
  return (dispatch, getState) => {
    dispatch(fetchGeolocationRiskOrgRequest());
    return axios(config.apiGateway.fetchGeolocationAtRiskToOrg, {
      method: 'POST',
      data: JSON.stringify({
        group_guid,
        selectedDatetime,
        aor,
        newReport,
      }),
    })
      .then((response) => {
        if (!newReport && response?.data?.output) {
          dispatch(
            fetchGeolocationRiskOrgSuccess(aor, response.data.output[0])
          );
          return;
        }
        interval = setInterval(() => {
          axios(config.apiGateway.fetchGeolocationAtRiskToOrg, {
            method: 'POST',
            data: JSON.stringify({
              group_guid,
              selectedDatetime,
              aor,
            }),
          })
            .then((pollResponse) => {
              if (pollResponse.data.status === 'Complete') {
                dispatch(
                  fetchGeolocationRiskOrgSuccess(
                    aor,
                    pollResponse.data.output[0]
                  )
                );
                clearInterval(interval);
              } else if (pollResponse.data.status === 'Error') {
                dispatch(
                  fetchGeolocationRiskOrgError(
                    'Alerts processing error.  Please try again.'
                  )
                );
                clearInterval(interval);
              }
            })
            .catch((error) => {
              console.error('Error checking Alerts task status:', error);
              dispatch(fetchGeolocationRiskOrgError(error));
              clearInterval(interval);
            });
        }, 5000); // Check every 5 seconds
      })
      .catch((error) => {
        console.error('Error with Alerts task:', error);
        dispatch(fetchGeolocationRiskOrgError(error));
        clearInterval(interval);
      });
  };
}
